import React, { useEffect } from "react";
import CardListing from "../CardListing/CardListing";

import { useDispatch, useSelector } from "react-redux";
import { Button } from "antd";
import Footer from "components/footer/Footer";
import { useNavigate } from "react-router-dom";
import { getJobCards, roleSelector } from "features/jobinv/JobCardSlice";
import { ROLES } from "components/common/Constants";
import './home.css'; // Assuming you have a home.css file for styles
const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const role = useSelector(roleSelector);

  // useEffect(() => {
  //   dispatch(getJobCards());
  // }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        gridTemplateRows: "1fr auto auto",
      }}>
      <CardListing />
      <Footer />
    </div>
  );
};

export default Home;
